import * as React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DrawingIcon from "@material-ui/icons/AddLocation";
import ReportIcon from "@material-ui/icons/Assessment";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Map from "../../views/Map/Map.jsx";
import Report from "../../views/Report/Report.jsx";
import Report2 from "../../views/Report/Report2.jsx";
import { makeStyles } from "@material-ui/core/styles";
import { BrowserRouter, Link, Route, Switch } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	customTab: {
		width: "100%",
	},
}));
export default function IconTabs() {
	const routes = ["/Map", "/Report", "/Report2", "/UserDropDown"];
	const basepath = "/user";

	const classes = useStyles();

	return (
		<BrowserRouter>
			<Route
				path="/"
				render={(routeProps) => (
					<AppBar position="sticky" className={classes.customTab}>
						<Toolbar>
							<Tabs
								value={routeProps.location.pathname !== "/" ? routeProps.location.pathname : false}
								aria-label="icon tabs example"
							>
								<Tab
									id="MapsTab"
									icon={<DrawingIcon />}
									title={"Project Management"}
									aria-label="Drawing"
									value={basepath + routes[0]}
									component={Link}
									to={basepath + routes[0]}
								/>
								<Tab
									id="Reports2Tab"
									icon={<ReportIcon />}
									title={"Report 2"}
									aria-label="Report 2"
									value={basepath + routes[2]}
									component={Link}
									to={basepath + routes[2]}
								/>
								<Tab
									id="ReportsTab"
									icon={<ReportIcon />}
									title={"Report"}
									aria-label="Report"
									value={basepath + routes[1]}
									component={Link}
									to={basepath + routes[1]}
								/>
							</Tabs>
						</Toolbar>
					</AppBar>
				)}
			/>
			<Switch>
				<Route path="/user/Map" component={Map} />
				<Route path="/user/Report" component={Report} />
				<Route path="/user/Report2" component={Report2} />
			</Switch>
		</BrowserRouter>
	);
}
